import Vue from 'vue'
import App from './App.vue'
import router from './router/home'
import store from './store'
import "@/assets/style/index.css"
import VueClipboard from 'vue-clipboard2'
import * as filters from '@/filters'
import metaPlugin from './metaPlugin';

// import { Component } from 'vue-property-decorator';

// Register asyncData hook
// Component.registerHooks(['asyncData']);

Vue.config.productionTip = false

Object.keys(filters).forEach(key => {
  Vue.filter(key, (filters as { [key: string ]: Function })[key])
})

Vue.directive('real-img', async function (el, binding) {
  //指令名称为：real-img
  let imgUrl = binding.value //获取图片地址
  if (imgUrl) {
    let exist = await imageIsExist(imgUrl)
    if (exist) {
      el.setAttribute('src', imgUrl)
    } else {
      imgUrl = imgUrl.replace('http://', 'https://')
      let existHttps = await imageIsExist(imgUrl)
      if (existHttps) {
        el.setAttribute('src', imgUrl)
      } else {
      }
    }
  }
})

/**
 * 检测图片是否存在
 * @param url
 */
const imageIsExist = function(url: string) {
  return new Promise((resolve) => {
    let img = new Image() as any
    img.onload = function () {
      if (this.complete == true){
        resolve(true)
        img = null
      }
    }
    img.onerror = function () {
      resolve(false)
      img = null
    }
    img.src = url
  })
}

VueClipboard.config.autoSetContainer = true // add this line
Vue.use(VueClipboard)
Vue.use(metaPlugin);
// 创建一个 createApp 函数，用于创建和配置 Vue 应用程序实例
export function createApp() {
  const app = new Vue({
    router,
    store,
    render: (h) => h(App),
  });

  return { app, router, store };
}